import Vue from 'vue'
import App from './inform.vue'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#inform',
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/pages/informatiList/inform.js